import { ReactComponent as BadgeIcon } from "../../../assets/icons/badge-2.svg";
import { SignedImage } from "./SignedImage";

interface BadgeImageProps {
    /** Bucket-root S3 key of the badge icon (resolved to a signed URL). */
    iconUrl?: string;
    alt?: string;
    className?: string;
}

export function BadgeImage({ iconUrl, alt, className }: BadgeImageProps) {
    return (
        <SignedImage
            imageKey={iconUrl}
            alt={alt}
            className={className}
            sizeClassName="w-[60px] h-[60px]"
            skeletonClassName="rounded-full"
            fallback={(sizeClasses) => <BadgeIcon className={sizeClasses} />}
        />
    );
}
